// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## GoogleMap GetAddressWithAddress
/**
 *
 * @param {{params: object, query: { address: string}} } option
 *
 * @returns
 */
export const GetAddressWithAddress = async (option) => {
  const response = await $api.get(
    Endpoints.GoogleMap.GetAddressWithAddress(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## GoogleMap GetAddressWithCoordinate
/**
 *
 * @param {{params: object, query: { lattitude: string, longitude: string}}} option
 *
 * @returns
 */
export const GetAddressWithCoordinate = async (option) => {
  const response = await $api.get(
    Endpoints.GoogleMap.GetAddressWithCoordinate(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};

export default {
  GetAddressWithAddress,
  GetAddressWithCoordinate,
};
